import { useMemo } from 'react';
import { SEAT_CIRCLE_RADIUS } from '../../constants';
import { ceil, floor, round } from '../../utils/utils';
export var useGenericRow = function (_a) {
    var containerSize = _a.containerSize, labelGenerator = _a.labelGenerator, seatAmount = _a.seatAmount, _b = _a.reverse, reverse = _b === void 0 ? false : _b, _c = _a.disablePadding, disablePadding = _c === void 0 ? false : _c;
    var emptySpace = containerSize - seatAmount * SEAT_CIRCLE_RADIUS * 2;
    var spacing = 0;
    if (emptySpace > 0) {
        spacing = disablePadding ? emptySpace / (seatAmount - 1) : emptySpace / (seatAmount + 1);
    }
    else if (seatAmount > 1) {
        spacing = floor(emptySpace / (seatAmount - 1));
    }
    var sidePadding = emptySpace > 0 && !disablePadding ? spacing : 0;
    var seats = useMemo(function () {
        var newSeats = new Array(seatAmount).fill(null).map(function () { return ({
            label: labelGenerator.next().value.toString(),
        }); });
        if (reverse) {
            newSeats.reverse();
        }
        return newSeats;
    }, [seatAmount, reverse, labelGenerator]);
    var getSeatPosition = function (index) {
        var position = sidePadding + SEAT_CIRCLE_RADIUS * 2 * index + spacing * index;
        if (index === 0) {
            return ceil(position);
        }
        else if (index === seatAmount - 1) {
            return floor(position);
        }
        else {
            return round(position);
        }
    };
    return { seats: seats, getSeatPosition: getSeatPosition };
};
//# sourceMappingURL=use-generic-row.js.map